import React from 'react';
import { connect } from 'react-redux';

import copy from 'copy-to-clipboard';
import Alert from 'react-s-alert';

import Accordion from 'react-bootstrap/Accordion';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';

import SocialShare from '../../../components/SocialShare/SocialShare';
import { ButtonLink } from '../../../components/UI/TextLink/TextLink';
import classes from './PersonalInformation.css';

class PersonalInformation extends React.Component{

    componentDidMount() {
        this.shareUrl = window.location.origin + "/schedule/" + this.props.calendarId;
        this.shareTitle = 'Book a call with ' + this.props.firstName;
    }

    handleCopy = () => {
        let calendarUrl = this.shareUrl;
        copy(calendarUrl);
        Alert.info('link is copied to clipboard');
    }

    render(){

        let shareUrl = window.location.origin + "/schedule/" + this.props.calendarId;
        let viewUrl = window.location.origin + "/view-my-calendar/" + this.props.calendarId;
        let shareTitle = 'Book a call with ' + this.props.firstName;

        let copyLink;
        let displaySize;
        if (this.props.isMobile === true) {
            displaySize = 'none';
            copyLink = (
                <div>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>Calendar</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl disabled placeholder={this.props.calendarId}/>
                </InputGroup>
                <InputGroup className="mb-3">
                    <Button size='none' block variant="info" onClick={this.handleCopy} id='copy-button-id'>Copy Calendar Link</Button>
                </InputGroup>
                </div>
            );
        }
        else {
            displaySize = 'none';
            copyLink = (
                <InputGroup className="mb-3">
                    <InputGroup.Prepend className={classes.PrependButton}>
                        <Button variant="info" block onClick={this.handleCopy} >Copy Calendar Link</Button>
                    </InputGroup.Prepend>
                    <FormControl disabled placeholder={this.props.calendarId}/>
                </InputGroup>
            );
        }

        return (
        <Container>
            <Card bsPrefix={classes.CardBody}>
            <Card.Header><b>Personal Information</b></Card.Header>
            <Card.Body>
                <InputGroup size={displaySize} className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>First Name</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl disabled placeholder={this.props.firstName}/>
                </InputGroup>
                <InputGroup size={displaySize} className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text>Last Name</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl disabled placeholder={this.props.lastName}/>
                </InputGroup>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                        <InputGroup.Text size='sm'>Email</InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl disabled placeholder={this.props.email}/>
                </InputGroup>
                { copyLink }

                <Accordion>
                <Accordion.Toggle as={Button} variant="link" eventKey="0">
                    <div className={classes.LinkShareText}>How to share my calendar link?</div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body className={classes.LinkShareInstruction}>
                        <InputGroup className="mb-3">
                            <SocialShare shareUrl={shareUrl} shareTitle={shareTitle}></SocialShare>
                        </InputGroup>
                        <InputGroup>
                            <div className={classes.LinkShareInstructionText}>
                            Please copy the above link and share it to your friend through social media, text, email, etc. Your friends will be able to book a time with you using the link. 
                            Or you can visit your <a href={viewUrl}> calendar</a> page and share it using the share button in your browser.
                            </div>
                        </InputGroup>
                    </Card.Body>
                </Accordion.Collapse>

                </Accordion>

                <Accordion>

                <Accordion.Toggle as={Button} variant="link" eventKey="1">
                    <div className={classes.LinkShareText}>
                        More options <Badge variant="info">cutomization</Badge>
                    </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                    <div className={classes.MoreOptions}>
                        <Row>
                            <Col>
                            <div className={classes.TextLinkButton}>
                            <ButtonLink size="none" link={'/calendar-management/'+ this.props.calendarId +'/'} text="Customize My Calendar"></ButtonLink>
                            </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                            <div className={classes.TextLinkButton}>
                            <ButtonLink size="none" link={'/view-my-calendar/'+ this.props.calendarId +'/'} text="View My Calendar"></ButtonLink>
                            </div>
                            </Col>
                        </Row>
                    </div>
                </Accordion.Collapse>

                </Accordion>

            </Card.Body>
            </Card>
        </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        calendarId: state.auth.calendarId,
        firstName: state.auth.firstName,
        lastName: state.auth.lastName,
        email: state.auth.userId,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (PersonalInformation);


// WEBPACK FOOTER //
// ./src/containers/Profile/PersonalInformation/PersonalInformation.js